import * as actionTypes from './types';

export const theme = {
	set:
		(data: any) => async (dispatch: any) => {
			dispatch({
				type: actionTypes.SET_DATA,
				payload: data,
			});
		}
};